import CloseIcon from "@mui/icons-material/Close";
import LoginIcon from "@mui/icons-material/Login"; // Import the desired icon
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { verifyUser } from "../../API/API";
import {
  handleOpenContactUs,
  handleOpenPrivacyPolicy,
  handleOpenTermsOfService,
  showToast,
} from "../../components/common/Util/Util";
import CallIcon from "@mui/icons-material/Call";
const LoginScreen = ({
  showLoginScreen,
  setShowLoginScreen,
  setShowRegister,
  setShowOTPVarification,
  setShowMobileOTP,
  setRequestData,
  requestData,
}) => {
  const ip = useSelector((state) => state.user.ip);
  const inputRef = useRef(null);
  const cordinates = useSelector((state) => state.user.cordinates);
  const [isLoading, setIsLoading] = useState(false);
  const {
    control,
    setValue,
    getValues,
    setError,
    formState: { errors },
  } = useForm();

  // Autofocus using ref on mount
  useEffect(() => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 200);
  }, []);
  useEffect(() => {
    if (requestData?.mobileNumber) {
      setValue(
        "mobileNumber",
        requestData?.mobileNumber?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")
      );
    }
  }, []);
  const handleLogin = (from) => {
    const data = getValues(); // from react-hook-form
    onSubmit({ ...data, continueAs: from });
  };
  const onSubmit = async (data) => {
    if (isLoading) {
      return;
    }
    if(!data?.mobileNumber||data?.mobileNumber?.replace(/-/g, "")?.length<10){
      setError("mobileNumber", { type: "manual", message: "Mobile number must be 10 digits" });
      return;
    }
    
    setIsLoading(true);
    try {
      const registerRequest = {
        name: "",
        mobileNumber: data?.mobileNumber?.replace(/-/g, ""),
        email: "",
        userType: "",
        ip: ip||"",
        longitude: String(cordinates?.lng ? cordinates?.lng : ""),
        latitude: String(cordinates?.lat ? cordinates?.lat : ""),
        screen: "login",
        continueAs: data?.continueAs,
      };

      setRequestData(registerRequest);
      const res = await verifyUser(registerRequest); // await the API call
      if (res?.statusCode === 200) {
        showToast(res.message, "success");
        setShowOTPVarification(true);
        setShowMobileOTP(true);
      } else {
        showToast("User Not Found!", "error");
        setShowRegister(true);
      }
      handleClose();
    } catch (e) {
      console.error(e, "error");
      if (e?.response?.data?.message === "User Not Found!!") {
        setShowRegister(true);
        showToast("User Not Found!", "error");
        handleClose();
      } else {
        console.error(e, "error");
        showToast("Oops! Something went wrong.", "error");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setShowLoginScreen(false);
  };

  return (
    <Dialog
      open={showLoginScreen}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "20px",
        },
      }}
    >
      <DialogContent sx={{ padding: 0, position: "relative" }}>
        <CloseIcon
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            cursor: "pointer",
            zIndex: 2,
          }}
        />
        <Grid container sx={{ height: "100%" }}>
          {/* Image Section (Left Side) */}
          <Grid
            item
            xs={12}
            sm={5}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: `url('/fintech.png') center/cover no-repeat`,
              height: { xs: "200px", sm: "auto" }, // Adjust height for mobile
              borderTopLeftRadius: "20px",
              borderBottomLeftRadius: { xs: "0px", sm: "20px" }, // Prevents border issue on mobile
            }}
          />

          {/* Form Section (Right Side) */}
          <Grid
            item
            xs={12}
            sm={7}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              padding: { xs: "1rem", sm: "2rem" },
            }}
          >
            {/* Logo at Top Center */}
            <Box sx={{ textAlign: "center", mb: 3 }}>
              <img src="/dequiLogo.png" alt="Logo" style={{ width: "150px" }} />
            </Box>

            <Typography
              variant="h6"
              gutterBottom
              sx={{ color: "#003A91", fontWeight: 700, textAlign: "left" }}
            >
              Login to Your Account
            </Typography>
            <Typography
              sx={{
                mb: "1rem",
                color: "#555",
                fontSize: "0.9rem",
                fontStyle: "italic",
              }}
            >
              Enter your phone number to access your account.
            </Typography>

            {/* Phone Number Field */}
            <Controller
              name="mobileNumber"
              control={control}
              rules={{
                required: "Mobile number is required",
                validate: (value) => {
                  const digitsOnly = value.replace(/\D/g, "");
                  return (
                    digitsOnly.length === 10 ||
                    "Mobile number must be 10 digits"
                  );
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  inputRef={inputRef}
                  value={field.value || ""}
                  variant="outlined"
                  fullWidth
                  label={
                    <>
                      Mobile Number
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  type="tel"
                  autoFocus
                  autoComplete={"false"}
                  slotProps={{
                    htmlInput: {
                      maxLength: 10,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    },
                    inputLabel: { shrink: true },
                     input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <CallIcon />
                        </InputAdornment>
                      ),
                    },
                  }}
                  onInput={(e) => {
                    setError("mobileNumber",{});
                    e.target.value.replace(/^\s+/, "");
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    e.target.value = e.target.value.replace(
                      /(\d{3})(\d{3})(\d{4})/,
                      "$1-$2-$3"
                    );
                    field.onChange(e);
                  }}
                  // onPaste={(e) => {
                  //   e.preventDefault(); // ❌ Block paste
                  //   // showToast("Pasting is not allowed!", "error");
                  // }}
                  sx={{ mb: "1rem" }}
                  error={!!errors.mobileNumber}
                  placeholder="XXX-XXX-XXXX"
                  helperText={errors.mobileNumber?.message}
                />
              )}
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={isLoading}
              startIcon={<LoginIcon />} // Icon added here
              onClick={(e) => {
                if (e.detail !== 0) handleLogin();
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleLogin();
              }}
              sx={{
                margin: "0 auto", // Center align (optional)
                maxWidth: 350, // Width reduced
                backgroundColor: "#003A91",
                "&:hover": { backgroundColor: "#002570" },
                "&:disabled": { 
                  backgroundColor: "#ccc", 
                  color: "#666" 
                },
                height: "40px",
                marginBottom: "1rem",
              }}
            >
              {isLoading ? "Processing..." : "Sign In"}
            </Button>
            {/* Register Option */}

            
            <Button
              type="submit"
              variant="outlined"
              fullWidth
              disabled={isLoading}
              startIcon={<LoginIcon />} // Icon added here
               onClick={() => {
                  handleClose();
                  setShowRegister(true);
                }}
              sx={{
                margin: "0 auto", // Center align (optional)
                maxWidth: 350, // Width reduced
                // backgroundColor: "#003A91",
                "&:hover": { backgroundColor: "#ccc" },
                "&:disabled": { 
                  backgroundColor: "#ccc", 
                  color: "#003A91" 
                },
                borderColor: "#003A91",
                height: "40px",
                marginBottom: "1rem",
              }}
            >
              {isLoading ? "Processing..." : "Sign Up"}
            </Button>
            {/* <Typography
              sx={{
                mt: "0.5rem",
                textAlign: "center",
                fontSize: "0.9rem",
                color: "#003A91",
              }}
            >
              Don’t have an account?{" "}
              <Link
                onClick={() => {
                  handleClose();
                  setShowRegister(true);
                }}
                sx={{ fontWeight: "bold", color: "#003A91", cursor: "pointer" }}
              >
                Register Now
              </Link>
            </Typography> */}
            {/* reCAPTCHA Disclaimer */}
            <Typography
              sx={{
                textAlign: "center",
                fontSize: "0.8rem",
                color: "#777",
                mt: "1rem",
              }}
            >
              This site is protected by reCAPTCHA and the{" "}
              <Link onClick={handleOpenPrivacyPolicy}>Privacy Policy</Link> and{" "}
              <Link onClick={handleOpenTermsOfService}>Terms of Service</Link>{" "}
              apply. For more info,{" "}
              <Link onClick={handleOpenContactUs}>Contact Us</Link>.
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default LoginScreen;
